import { defineStore } from 'pinia'
export const useLoadingStore = defineStore('loading', {
  state: () => ({
    loading: false
  }),
  getters: {
    getLoading: function () {
      return this.loading
    }
  },
  actions: {
    setLoading: function (state) {
      this.loading = state
    }
  }
})
